export const getPlatformNameForStats = (environment: string) => {
    if (environment.includes("jetbrains")) {
        return "jetbrains";
    } else if (environment === "vscode"){
        return "vscode";
    } else if (environment.includes("ios")) {
        return "ios";
    } else if (environment.includes("android")) {
        return "android";
    } else if (environment.includes("chrome")) {
        return "chrome";
    } else if (environment.includes("web")) {
        return "web"
    }
}

export const isIde = (environment: string | null) => {
    return environment === "vscode" || environment?.includes("jetbrains");
}

export const sendMessageToIde = (environment: string, vscode: any, functionName: string, data: any) => {
    if (environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify({functionName, data}));
    else vscode.postMessage({ functionName, data });
}

export const sendMessageToMobile = (functionName: string, data: any) => {
    try {
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
            window.ReactNativeWebView.postMessage(JSON.stringify({functionName, data}));
        } else {
            console.error('ReactNativeWebView is not available');
        }
    } catch (error) {
        console.error('Failed to send message to React Native:', error);
    }
}

export const isMobileApp = (environment: string | null) => {
    return environment === "mobile_ios" || environment === "mobile_android";
}

/**
 * Checks if the current environment is Chrome browser
 * @param environment - The environment string from app state
 * @returns true if environment contains "chrome"
 */
export const isChrome = (environment: string | null) => {
    return environment?.includes("chrome");
}

export const getFormattedEnvName = (env: string) => {
    const lowercaseEnv = env.toLowerCase();

    if (lowercaseEnv.includes("mobile") && !lowercaseEnv.includes("web")) return "Mobile";
    else if (lowercaseEnv === "chrome") return "Chrome";
    else if (lowercaseEnv.includes("jetbrains") || lowercaseEnv === "vscode") return "IDE";
    else return "Web"
};

export const formatSystemDetails = (systemDetails: any) => {
    let systemDetailsString = "\`\`\`\n";

    // OS Section
    if ("osName" in systemDetails || "osVersion" in systemDetails || "osArch" in systemDetails) {
        systemDetailsString += "Operating System:";
        if ("osName" in systemDetails) {
            systemDetailsString += `\n  Name: ${systemDetails["osName"]}`;
        }
        if ("osVersion" in systemDetails) {
            systemDetailsString += `\n  Version: ${systemDetails["osVersion"]}`;
        }
        if ("osArch" in systemDetails) {
            systemDetailsString += `\n  Architecture: ${systemDetails["osArch"]}`;
        }
    }

    // IDE Section
    if ("ideName" in systemDetails) {
        systemDetailsString += "\n\nIDE Information:";
        systemDetailsString += `\n  Name: ${systemDetails["ideName"]}`;
    }

    // Project Section
    if ("projectBasePath" in systemDetails) {
        systemDetailsString += "\n\nProject Information:";
        systemDetailsString += `\n  Base Path: ${systemDetails["projectBasePath"]}`;
    }

    // Environment Section
    if ("shell" in systemDetails) {
        systemDetailsString += "\n\nEnvironment:";
        systemDetailsString += `\n  Shell: ${systemDetails["shell"]}`;
    }

    systemDetailsString += "\n\`\`\`\n";
    return systemDetailsString;
}
